/**
 * Good Morning - New Tab by cloudHQ
 *
 * Overrides the new-tab page and exposes a broad web-accessible-resource entry
 * (javascripts, icons, fonts, html and a catch-all) with no `use_dynamic_url`, but
 * scoped to cloudhq.net origins only. So resources like icons/gmail_dashboard.png and
 * html/newtab.html load at a fixed URL, yet only a page on cloudhq.net can reach them —
 * from anywhere else the fetch is blocked and a negative proves nothing.
 *
 * Manifest verified against version 1.0.2.21.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dpgeocgdkfaejeajppfdihkhbnpbjiik';

export const goodMorningCloudhq: ExtensionDefinition = {
  id: ID,
  name: 'Good Morning - New Tab by cloudHQ',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 9_000,
  requiredOrigin: 'https://www.cloudhq.net',
  notes:
    'Static WAR (icons, html, javascripts) scoped to cloudhq.net, so only that origin ' +
    'can detect it. gmail_dashboard.png and newtab.html are stable named files.',
  signals: [
    {
      id: 'war-gmail-dashboard-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch icons/gmail_dashboard.png — the extension icon exposed only to cloudhq.net.',
      weight: 1,
      run: () => probeFetch(ID, 'icons/gmail_dashboard.png'),
    },
    {
      id: 'war-newtab-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch html/newtab.html — the new-tab override page, a second origin-scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'html/newtab.html'),
    },
  ],
};
